import axios from "@/plugins/axios.js";
import helpersJs from "@/plugins/helpers";

export default {
  async getTables() {
    const tables = await axios.getData(
      "/auth/get-database-tables",
      localStorage.getItem("token")
    );
    return tables;
  },
  async getTableData(table) {
    const tableData = await axios.postDataWithToken(
      "/auth/get-table-data",
      { table },
      localStorage.getItem("token")
    );
    return tableData;
  },
  filterStuffOutOfColumnNames(columnsArray, userEmail = null) {
    const columns = [];
    if (columnsArray.length > 0) {
      columnsArray.forEach((column) => {
        if (userEmail && userEmail == "adubyte2@yahoo.com") {
          if (
            column != "selection" &&
            column != "id" &&
            column != "item_type"
          ) {
            columns.push(column);
          }
        } else if (
          column != "selection" &&
          column != "emis" &&
          column != "id" &&
          column != "item_type"
        ) {
          columns.push(column);
        }
      });
    }
    return columns;
  },
  formatColumnsArrayAsColumnHeaders(columnsArray) {
    const columnsHeaders = [{ text: "Select", value: "selection" }];
    if (columnsArray.length > 0) {
      columnsArray.forEach((column) => {
        columnsHeaders.push({
          text: this.formatTableName(column),
          value: column,
        });
      });
    }
    return columnsHeaders;
  },
  async getTableColumnNames(table) {
    const columnData = await axios.postDataWithToken(
      "/auth/get-columns",
      { table },
      localStorage.getItem("token")
    );
    return columnData;
  },
  getTableColumnHeadersFromRowObject(tableRowObject, userEmail = null) {
    let columnsArray = Object.keys(tableRowObject);
    columnsArray = this.filterStuffOutOfColumnNames(columnsArray, userEmail);
    columnsArray = this.formatColumnsArrayAsColumnHeaders(columnsArray);
    return columnsArray;
  },
  formatTableName(tableName) {
    let table = "";
    if (tableName && tableName.includes("_")) {
      table = tableName.replace("_", " ");
    } else {
      table = tableName;
    }

    const names = table.split(" ");
    if (names.length > 1) {
      let parts = "";
      names.forEach((tab) => {
        parts += helpersJs.capitalizeFirstCharacter(tab) + " ";
      });
      table = parts;
    } else {
      table = helpersJs.capitalizeFirstCharacter(names[0]);
    }
    return table;
  },
};
